import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';
import { getRefundStatusMessageDescriptor } from '../../../refund-status/refund-status-mappings';
import { REFUND_STATUS } from '../../../../filters/constants';

import { messages } from './messages';

const getDisplayName = (appliedFilters = []) => {
  const refundStatusFilters = appliedFilters?.filter((currentFilter) => currentFilter.filterById === REFUND_STATUS);

  if (refundStatusFilters?.length === 0) {
    return <FormattedMessage {...messages.defaultFilterText} />;
  }

  if (refundStatusFilters.length === 1) {
    const statusTypeId = refundStatusFilters[0]?.criterionArgumentValue;
    const messageDescriptor = getRefundStatusMessageDescriptor(Number(statusTypeId));

    if (messageDescriptor) {
      return <FormattedMessage {...messageDescriptor} />;
    }

    return String(statusTypeId);
  }

  return <FormattedMessage {...messages.multipleStatuses} />;
};

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters),
  };
};

export const RefundStatus = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
